import { useCallback, useEffect, useState } from "react";
import { literals } from "@/constants/literals";
import InputSelect from "@/components/input-select/InputSelect";
import Textarea from "@/components/textarea/Textarea";
import {
  CAPTURE_DESCRIPTION_OPTIONS,
  PACKAGING_STEP_DESCRIPTION_OPTIONS,
} from "@/constants/selectsLists";
import NacelleFinfingsInputSearchSelect from "@/components/input-search-select/NacelleFinfingsInputSearchSelect";

export interface DescriptionEditionContentProps {
  step: string;
  isNacelleFindings: boolean;
  changeDescription: (neDescription: string) => void;
  description: string | null;
}

const DescriptionEditionContent = ({
  step,
  isNacelleFindings,
  changeDescription,
  description,
}: DescriptionEditionContentProps) => {
  const [descriptionType, setDescriptionType] = useState("");
  const [extraInformation, setExtraInformation] = useState("");
  const [textDescription, setTextDescription] = useState("");

  useEffect(() => {
    if (
      (step === literals.inNoServ || step === literals.packagingAction) &&
      description &&
      description.length > 0
    ) {
      const firstColom = description.indexOf(":");
      if (firstColom === -1) {
        setDescriptionType(description);
        setExtraInformation("");
      } else {
        setDescriptionType(description.slice(0, firstColom));
        setExtraInformation(description.slice(firstColom + 1).trim());
      }
    } else {
      setDescriptionType("");
      setExtraInformation("");
      setTextDescription(description as string);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeOnltexDescription = useCallback(
    (newDescription: string) => {
      changeDescription(newDescription);
      setTextDescription(newDescription);
    },
    [changeDescription],
  );

  const changeDescriptionType = useCallback(
    (selectedDescription: string) => {
      setDescriptionType(selectedDescription);
      if (extraInformation.trim().length > 0) {
        changeDescription(`${selectedDescription}: ${extraInformation}`);
      } else {
        changeDescription(selectedDescription);
      }
    },
    [extraInformation, changeDescription],
  );

  const changeExtraInformation = useCallback(
    (newExtraInfo: string) => {
      setExtraInformation(newExtraInfo);
      if (newExtraInfo.trim().length > 0) {
        changeDescription(`${descriptionType}: ${newExtraInfo}`);
      } else {
        changeDescription(descriptionType);
      }
    },
    [descriptionType, changeDescription],
  );

  const renderElements = () => {
    const renderInputs = (condition: string) => {
      switch (condition) {
        case "inNOSERV":
          return (
            <>
              <div className="w-full mb-4">
                <InputSelect
                  size="medium"
                  label={literals.description}
                  id="description"
                  name="description"
                  options={CAPTURE_DESCRIPTION_OPTIONS}
                  onChange={changeDescriptionType}
                  value={descriptionType}
                  required
                  placeholder={literals.chooseAnOption}
                />
              </div>
              <Textarea
                label={literals.extraInformation}
                onChange={changeExtraInformation}
                name="description"
                value={extraInformation}
                deleteMessage={literals.cleanExtrainfo}
                size="medium"
                required={descriptionType === "Others"}
              />
            </>
          );
        case "packaging":
          return (
            <>
              <div className="w-full mb-4">
                <InputSelect
                  size="medium"
                  label={literals.description}
                  id="description"
                  name="description"
                  options={PACKAGING_STEP_DESCRIPTION_OPTIONS}
                  onChange={changeDescriptionType}
                  value={descriptionType}
                  required
                  placeholder={literals.chooseAnOption}
                />
              </div>
              <Textarea
                label={literals.extraInformation}
                onChange={changeExtraInformation}
                name="description"
                value={extraInformation}
                deleteMessage={literals.cleanExtrainfo}
                size="medium"
                required={description === "Others"}
              />
            </>
          );
        case "nacelle":
          return (
            <NacelleFinfingsInputSearchSelect
              label={literals.description}
              id={"description"}
              name="description"
              value={textDescription}
              size={"medium"}
              onChange={(new_value: string) =>
                changeOnltexDescription(new_value)
              }
            />
          );
        default:
          return (
            <Textarea
              label={literals.description}
              onChange={changeOnltexDescription}
              name="description"
              value={textDescription}
              deleteMessage={literals.cleanDescription}
              size="medium"
            />
          );
      }
    };
    if (step === literals.inNoServ) return renderInputs("inNOSERV");
    if (step === literals.packagingAction) return renderInputs("packaging");
    if (isNacelleFindings) return renderInputs("nacelle");
    return renderInputs("other");
  };

  return <div>{renderElements()}</div>;
};

export default DescriptionEditionContent;
